<template>
  <div style="padding: 50px;">
    <v-alert
      outlined
      type="warning"
      prominent
      border="left"
    >
      Debe seleccionar un entorno y un �rea de trabajo. Para hacerlo seleccione una opci�n del men� superior.  
    </v-alert>
  </div>
</template>
<script>
import constants from '@/constants'
import api from '@/services/api'
import utils from '@/services/utils'
export default {
  data: () => ({
    environment: null,
    environments: [],
  }),
  computed: {
    isMobile () {
      return utils.isMobile()
    },
  },
  mounted () {
    if (this.isMobile) this.init()
  },
  methods: {
    prepareColor (v) {
      if (v === 'status') {
        this.$vuetify.theme.themes.light.primary = '#000000'
      } else if (v === 'status2') {
        this.$vuetify.theme.themes.light.primary = '#000000'
      } else {
        this.$vuetify.theme.themes.light.primary = '#374047'
      }
    },
    init () {
      api.getItem ('system', `v1/internal/environments/`, utils.getUser())
        .then(response => {
          this.environments = constants.environments.filter(x => response.Environments.indexOf(x.name) >= 0)
          if (this.environments.length === 0) return
          else if (!this.environment) this.handleGoTo(this.environments[0])
        })
    },
    handleGoTo (v) {
      if (v.name !== 'dtouch') this.$store.state.app.dtouchDeeplTranslateActive = false
      if (v.path !== `/${this.environment}`) { 
        this.prepareColor(v.name)
        this.$store.state.app.environment = v.name
        this.$router.push(v.path)
      }
    }
  },
}
</script>

